import { useTheme } from '@automata/mui-theme';
import { memo } from 'react';

import { SemicontrolledInput } from '../SemicontrolledInput';

export type Props = {
  value: string;
  onChange: (newValue: string) => void;
};

const WorkflowNameInput = ({ value, onChange }: Props) => {
  const theme = useTheme();

  const width = `${value.length * 1.05}ch`;
  const minWidth = '15em';
  const maxWidth = '60vw';

  return (
    <SemicontrolledInput
      handleSaveValue={onChange}
      value={value}
      TextFieldProps={{
        variant: 'standard',
        sx: { width, minWidth, maxWidth },
        inputProps: {
          sx: {
            ...theme.typography.h6,
            padding: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          },
        },
        InputProps: {
          sx: {
            '::before': {
              transition: 'opacity 0.2s',
              opacity: 0,
            },
            '&:hover': {
              '::before': {
                opacity: 1,
              },
            },
          },
        },
      }}
    />
  );
};

export default memo(WorkflowNameInput);
